import {
  LangSelectProfile,
  LangLabel,
  LangShortLabel,
  LangKey,
} from './language.constants';

export const NUMBER_OF_SELECT_CHANGE = 3;

export const LANGUAGE_SELECT: LangSelectProfile[] = [
  {
    label: LangLabel.ru,
    shortLabel: LangShortLabel.ru,
    value: '1',
    keyLanguage: LangKey.ru,
  },
  {
    label: LangLabel.en,
    shortLabel: LangShortLabel.en,
    value: '2',
    keyLanguage: LangKey.en,
  },
];

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortEntity {
  dateBegin = 'dateBegin',
  sizeMax = 'sizeMax',
  company = 'company',
  timeCreate = 'timeCreate',
}

export enum TopDiscountSortEntity {
  companyTitle = 'companyTitle',
  clicksCount = 'clicksCount',
}

export type TopDiscountSortParam = 'name' | 'clicks';

export const TOP_DISCOUNT_SORT_PARAM: Record<
  TopDiscountSortEntity,
  TopDiscountSortParam
> = {
  [TopDiscountSortEntity.companyTitle]: 'name',
  [TopDiscountSortEntity.clicksCount]: 'clicks',
};

export type DiscountSortOption = {
  entity: SortEntity;
  direction: SortDirection;
};

export type TopDiscountsSortOption = {
  entity: TopDiscountSortEntity;
  direction: SortDirection;
};

export const DISCOUNT_SORT_SELECT: DiscountSortOption[] = [
  { entity: SortEntity.dateBegin, direction: SortDirection.DESC },
  { entity: SortEntity.company, direction: SortDirection.ASC },
  { entity: SortEntity.company, direction: SortDirection.DESC },
];
